import { Link } from 'react-router-dom';
import { TinyUser } from '../../types/userProfile';
import Avatar from '../images/avatar';
import { HStack } from '../layouts/stack.layout';
import Text from '../typography/v2/text';

type UserLinkButtonProps = {
  to: string;
  user: TinyUser;
  variant?: 'sm' | 'base';
};

export default function UserLinkButton({
  to,
  variant,
  user,
}: UserLinkButtonProps) {
  return (
    <Link to={`/${to}`}>
      <HStack
        extensions="items-center hover:bg-white/50 ease-in transition-colors bg-white/25 pl-1 py-1 pr-4 rounded-full"
        gap="sm"
      >
        <Avatar
          url={user.avatarUrl}
          alt={user.username}
          size={variant === 'sm' ? '2xs' : 'xs'}
          variant="rounded"
        />
        {variant !== 'sm' ? (
          <Text variant="username">{user.username}</Text>
        ) : (
          <div className="font-text font-medium text-xs text-primary">
            {user.username}
          </div>
        )}
      </HStack>
    </Link>
  );
}
